import {
  Component,
  Inject,
  AfterViewInit,
  ViewContainerRef,
  ViewChild,
  Type,
  EventEmitter
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'modal-confirmation',
  templateUrl: 'modal-confirmation.component.html',
  styleUrls: ['modal-confirmation.component.scss'],
  standalone: false
})
export class ModalConfirmationComponent implements AfterViewInit {
  @ViewChild('dynamicInsert', { read: ViewContainerRef }) dynamicInsert: ViewContainerRef;

  textMatcherValue: string = '';
  declineReason: string = '';

  constructor(
    public dialogRef: MatDialogRef<ModalConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalConfirmationModel
  ) {}

  isMainButtonDisabled() {
    if (!this.data.textMatcherValue) {
      return false;
    }
    return this.data.textMatcherValue != this.textMatcherValue;
  }
  ngAfterViewInit(): void {
    if (this.data.dynamicData) {
      this.dynamicInsert.clear();
      const dyynamicComponent = this.dynamicInsert.createComponent(
        this.data.dynamicData.template
      ).instance;
      if (this.data.dynamicData.data) {
        dyynamicComponent.data = this.data.dynamicData.data;
      }
      dyynamicComponent.closeModal.subscribe(() => this.dialogRef.close());
    }
  }

  save() {
    if (this.declineReason) {
      this.dialogRef.close(this.declineReason);
    }
  }
}

export interface ModalConfirmationModel {
  simpleDialog: boolean;
  title: string;
  action: string;
  description: string;
  delete: boolean;
  okButtonText: string;
  okButtonId: string;
  textMatcherValue: string;
  dynamicData?: DynamicData;
}

export class DynamicData {
  constructor(
    public template: Type<BaseDynamicTemplate<any>>,
    public data?: any
  ) {}
}

export class BaseDynamicTemplate<T> {
  data: T;
  closeModal = new EventEmitter();
}
